<template>
  <el-dialog
    v-drag
    title="PU"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="520px"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="dialog-content">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item label="柜号" prop="containerNumber">
          <!-- <el-input
            v-model="form.containerNumber"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-input> -->
          <el-select
            v-model="form.containerNumber"
            style="width: 100%"
            placeholder="请选择柜号"
          >
            <el-option
              v-for="item in containerNumberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="PU#" prop="puNo">
          <el-input
            v-model="form.puNo"
            placeholder="请输入PU#"
            style="width: 100%"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="PU日期" prop="puDate">
          <el-date-picker
            v-model="form.puDate"
            type="date"
            placeholder="选择日期时间"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialogfooter">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok('form')">
        确 定
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { modifyMBLPU } from '@/api/bill'
import dayjs from 'dayjs'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: [],
      form: {
        puDate: '',
        containerNumber: '',
        puNo: ''
      },
      loading: false,
      addressDropOption: [],
      rules: {
        puDate: [
          { required: true, message: '请输入PU日期', trigger: 'blur' }
        ],
        containerNumber: [
          { required: true, message: '请输入柜号', trigger: 'blur' }
        ],
        puNo: [
          { required: true, message: '请输入PU#', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    containerNumberOption() {
        return this.rowData.containers.map(item => {
            return {
                value: item.containerNumber,
                label: item.containerNumber
            }
        })
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$refs['form']?.resetFields()
        this.form = {
            puDate: this.rowData.puDate ? dayjs(this.rowData.puDate).format('YYYY-MM-DD') : '',
            containerNumber: this.rowData.containers[0]?.containerNumber,
            puNo: ''
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
        //   this.$emit('ok', this.form.podDate)
        try {
            const res = await modifyMBLPU({
                mblId: this.rowData.id,
                puDate: this.form.puDate,
                containerNumber: this.form.containerNumber,
                puNo: this.form.puNo
            })
            if (res.success) {
                this.$message.success('设置成功')
                this.$emit('ok')
            } else {
                this.$message.error(res.errorMessage)
            }
        } catch (error) {
            console.log(error)
        }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-content {
  width: calc(100% - 88px);
  margin: 0 auto;
}
.dialogfooter {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 20px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0 0 0 0;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-form-item__label {
  line-height: 30px !important;
}
/deep/ .el-col:nth-child(2n) {
  display: flex;
  justify-content: flex-end;
}
.label-title {
  span {
    color: red;
    font-size: 12px;
  }
}
.taxNum .el-form-item__label {
  display: flex;
}
.form-label {
  display: flex;
  align-items: center;
}
</style>
